/**
 * This file contains the runFunction that is executed when the AngularJS app is run.
 * It initializes various settings and configurations for the app.
 *
 * @module app.run
 * @requires $state
 * @requires $rootScope
 * @requires $location
 * @requires $timeout
 * @requires $interval
 * @requires appSettingsSvc
 * @requires $stateParams
 * @requires $window
 * @requires $transitions
 * @requires restoreUrlService
 * @requires $translate
 * @requires $http
 * @requires ngDialog
 * @requires CacheFactory
 * @requires MetaTags
 */
(function () {
    "use strict";

    angular.module("app").run(runFunction);

    runFunction.$inject = [
        "$state",
        "$rootScope",
        "$location",
        "$timeout",
        "$interval",
        // "$analytics",
        "appSettingsSvc",
        "$stateParams",
        "$window",
        "$transitions",
        "restoreUrlService",
        "$translate",
        "$http",
        "ngDialog",
        "CacheFactory",
        "MetaTags",
        "darkModeSvc",
        "thirdPartyLoader"
    ];
    function runFunction(
        $state,
        $rootScope,
        $location,
        $timeout,
        $interval,
        // $analytics,
        appSettingsSvc,
        $stateParams,
        $window,
        $transitions,
        restoreUrlService,
        $translate,
        $http,
        ngDialog,
        CacheFactory,
        MetaTags,
        darkModeSvc,
        thirdPartyLoader
    ) {
        // Initialize dark mode on app startup
        darkModeSvc.initialize();

        // Expose dark mode service to rootScope for easy access from templates
        $rootScope.darkModeSvc = darkModeSvc;

        // Initialize third-party script lazy loader
        thirdPartyLoader.init();

        if (!CacheFactory.get('defaultCache'))
            CacheFactory('defaultCache', {
                maxAge: 15 * 60 * 1000, // Items added to this cache expire after 15 minutes
                cacheFlushInterval: 60 * 60 * 1000, // This cache will clear itself every hour
                deleteOnExpire: 'aggressive', // Items will be deleted from this cache when they expire
                // storageMode: 'localStorage'
            });

        $http.defaults.cache = CacheFactory.get('defaultCache');

        if ($location.host() === "www.endeksa.com" || $location.host() === "preprod.endeksa.com") {
            $rootScope.downloadLink = "https://images.endeksa.com/";
        }
        else {
            $rootScope.downloadLink =
                "https://beta-images.endeksa.com/";
        }

        appSettingsSvc.siteUrl = $window.location.origin;

        // set language
        var keyLanguage = "en";
        try {
            keyLanguage = $window.localStorage.getItem("Language");
        } catch (err) {
            ngDialog.open({
                templateUrl: "app/shell/modal-error.html",
            });
            return false;
        }
        // var urlPath = $location.url();
        // if (urlPath.indexOf("/en/") === -1 && urlPath.indexOf("/tr/") === -1) {
        //     var urlPathString = urlPath.split("/");
        //     urlPathString[1] = keyLanguage;
        //     var path = urlPathString.join("/");
        //     if (path.indexOf('en/') === -1 && path.indexOf('tr/') === -1)
        //         path = path + '/';
        //     $window.redirected = "Location: " + $window.location.origin + path;
        //     $location.path(path);
        // }

        $state.defaultErrorHandler(function (error) {
            console.error(error);
        });

        $rootScope.MetaTags = MetaTags;

        $rootScope.lang = keyLanguage;
        $window.lang = keyLanguage;
        $window.wootricSettings = {
            account_token: "NPS-66c1ee71",
            language: keyLanguage.split('-')[0].toUpperCase(),
        };
        $window.ybug_settings.language_override = keyLanguage.split('-')[0];
        $window.ybug_settings.translations = {
            "tr": {
                "feedbackForm.Types.1": "Hata",
                "feedbackForm.Types.2": "Geliştirme",
                "feedbackForm.Types.3": "Soru",
                "feedbackForm.Types.4": "Geri Bildirim",
            }
        };
        document.tidioChatLang = keyLanguage === 'pt-PT' ? 'pt' : keyLanguage === 'es-ES' ? 'es' : keyLanguage;
        $http.defaults.headers.common["Accept-Language"] = keyLanguage;
        $stateParams.langcode = keyLanguage;
        $translate.use(keyLanguage);
        moment.locale(keyLanguage);
        $timeout(function () {
            moment.locale(keyLanguage);
        });

        $rootScope.assignCurrency();

        $rootScope.country = $rootScope.lang === 'pt-PT' ? 'portugal' : $rootScope.lang === 'es-ES' ? 'espana' : $rootScope.lang === 'tr' ? 'turkiye' : 'world';

        const isVideoaskMessage = message =>
            message.origin === "https://ask.endeksa.com" &&
            message.data &&
            message.data.type &&
            message.data.type.startsWith("videoask_");

        $window.addEventListener("message", message => {
            if (!isVideoaskMessage(message)) {
                return;
            }
            if (message.data.type === "videoask_contact_interacted") {
                if (window.location.href.indexOf('/properties/') > -1)
                    window.dataLayer.push({
                        event: "lead_sale_valuation_display",
                        currency: window.currency,
                        language: window.lang.split('-')[0]
                    });
                else if (window.location.href.indexOf('/agents/') > -1 || window.location.href.indexOf('/danisman/') > -1 || window.location.href.indexOf('/agentes/') > -1)
                    window.dataLayer.push({
                        event: "lead_sale_agent_display",
                        currency: window.currency,
                        language: window.lang.split('-')[0]
                    });
                else
                    window.dataLayer.push({
                        event: "lead_sale_other_display",
                        currency: window.currency,
                        language: window.lang.split('-')[0]
                    });
            }
            else if (message.data.type === "videoask_contact_updated") {
                if (window.location.href.indexOf('/properties/') > -1)
                    window.dataLayer.push({
                        event: "lead_sale_valuation_engage",
                        currency: window.currency,
                        language: window.lang.split('-')[0]
                    });
                else if (window.location.href.indexOf('/agents/') > -1 || window.location.href.indexOf('/danisman/') > -1 || window.location.href.indexOf('/agentes/') > -1)
                    window.dataLayer.push({
                        event: "lead_sale_agent_engage",
                        currency: window.currency,
                        language: window.lang.split('-')[0]
                    });
                else
                    window.dataLayer.push({
                        event: "lead_sale_other_engage",
                        currency: window.currency,
                        language: window.lang.split('-')[0]
                    });
            }
        });

        window.gclid = localStorage.getItem('gclid') || undefined;
        window.gaclient = localStorage.getItem('gaclient') || undefined;


        function get_ga_clientid() {
            var cookie = {};
            document.cookie.split(';').forEach(function (el) {
                var splitCookie = el.split('=');
                var key = splitCookie[0].trim();
                var value = splitCookie[1];
                cookie[key] = value;
            });
            return cookie.hasOwnProperty("_ga") ? cookie["_ga"].substring(6) : null;
        }

        function getSessionData() {
            const pattern = /_ga_5ZVE5PY6T3=GS\d\.\d\.(.+?)(?:;|$)/;
            const match = document.cookie.match(pattern);
            const parts = match?.[1].split("$");

            let tryCount = 0;
            if (!parts) {
                if (tryCount >= 10) {
                    return;
                }
                window.setTimeout(() => {
                    tryCount++;
                    getSessionData();
                }, 200);
                return;
            }

            window.gasessionId = parts.shift();
            window.gasessionNumber = parts.shift();
        }

        $timeout(function () {
            getSessionData();
            const gclid = $location.search().gclid;
            if (gclid) {
                localStorage.setItem('gclid', gclid);
            }
            window.gclid = gclid || localStorage.getItem('gclid') || undefined;

            const gaclient = get_ga_clientid();
            if (gaclient && !window.gaclient) {
                localStorage.setItem('gaclient', gaclient);
                window.gaclient = gaclient;
            }
            else
                window.gaclient = localStorage.getItem('gaclient') || undefined;
        });


        // if (typeof $window.videoask !== 'undefined' && $window.lang === 'tr' && $window.location.href.indexOf('ad=') === -1 && $window.location.href.indexOf('top=') === -1)
        //     $window.videoask.loadEmbed({
        //         "kind": "widget",
        //         "url": "https://ask.endeksa.com/ff8e0al58#gclid=" + window.gclid,
        //         "options": {
        //             "widgetType": "VideoThumbnailExtraLarge",
        //             "text": "Evinizi Güvenle Satın",
        //             "backgroundColor": "#00AEFF",
        //             "position": "bottom-left",
        //             "dismissible": true
        //         }
        //     });
        // else if ($window.lang === 'tr' && $window.location.href.indexOf('ad=') === -1 && $window.location.href.indexOf('top=') === -1)
        //     $window.VIDEOASK_EMBED_CONFIG = {
        //         "kind": "widget",
        //         "url": "https://ask.endeksa.com/ff8e0al58#gclid=" + window.gclid,
        //         "options": {
        //             "widgetType": "VideoThumbnailExtraLarge",
        //             "text": "Evinizi Güvenle Satın",
        //             "backgroundColor": "#00AEFF",
        //             "position": "bottom-left",
        //             "dismissible": true
        //         }
        //     };

        // if ($window.location.href.indexOf('ad=') === -1 && $window.location.href.indexOf('top=') === -1 && $window.location.host === 'www.endeksa.com')
        // if ($window.lang === 'tr')
        //     OneSignal.push(["init", {
        //         appId: "2d42aaca-84b0-4db5-a121-4ee72f0c4bef",
        //         safari_web_id: "web.com.endeksa",
        //         autoRegister: true,
        //         welcomeNotification: {
        //             "title": "Endeksa Güncellemeleri",
        //             "message": "Güncellemeleri aldığınız için teşekkürler!"
        //         },
        //         notifyButton: {
        //             enable: false,
        //             size: 'medium',
        //             theme: 'default',
        //             position: 'bottom-left',
        //             offset: {
        //                 bottom: '0px',
        //                 left: '0px',
        //                 right: '0px'
        //             },
        //             prenotify: true,
        //             showCredit: false,
        //             text: {
        //                 'tip.state.unsubscribed': 'Güncellemelere üye ol',
        //                 'tip.state.subscribed': "Güncellemelere üye oldunuz",
        //                 'tip.state.blocked': "Güncellemeleri engellediniz",
        //                 'message.prenotify': 'Güncellemelere üye olmak için tıklayın',
        //                 'message.action.subscribed': "Güncellemeleri aldığınız için teşekkürler!",
        //                 'message.action.resubscribed': "Güncellemelere üye oldunuz",
        //                 'message.action.unsubscribed': "Artık güncelleme almayacaksınız",
        //                 'dialog.main.title': 'Endeksa Güncellemeleri',
        //                 'dialog.main.button.subscribe': 'Üye Ol',
        //                 'dialog.main.button.unsubscribe': 'Üyelikten Çık',
        //                 'dialog.blocked.title': 'Güncellemeleri engellemeyi bırak',
        //                 'dialog.blocked.message': "Güncellemeleri almak için adımları izleyin:"
        //             }
        //         },
        //         promptOptions: {
        //             actionMessage: "Size en son güncellemeleri ve haberleri iletmek istiyoruz.",
        //             acceptButtonText: "İzin Ver",
        //             cancelButtonText: "İstemiyorum"
        //         }
        //     }]);
        // else
        //     OneSignal.push(["init", {
        //         appId: "2d42aaca-84b0-4db5-a121-4ee72f0c4bef",
        //         safari_web_id: "web.com.endeksa",
        //         autoRegister: true,
        //         welcomeNotification: {
        //             "title": "Endeksa Updates",
        //             "message": "Thanks for getting our updates!"
        //         },
        //         notifyButton: {
        //             enable: false,
        //             size: 'medium',
        //             theme: 'default',
        //             position: 'bottom-left',
        //             offset: {
        //                 bottom: '0px',
        //                 left: '0px',
        //                 right: '0px'
        //             },
        //             prenotify: true,
        //             showCredit: false
        //         },
        //         promptOptions: {
        //             actionMessage: "We would like to send our latest updates to you.",
        //             acceptButtonText: "Allow",
        //             cancelButtonText: "No, Thanks"
        //         }
        //     }]);
        if ($window.location.host.indexOf('localhost') === -1) {
            var TIME_DIFF_CACHE_KEY = 'time_diff_data';
            var TIME_DIFF_TTL = 24 * 60 * 60 * 1000; // 24 saat

            (function fetchAndCacheTimeDiff() {
                var cachedTimeDiff = localStorage.getItem(TIME_DIFF_CACHE_KEY);
                if (cachedTimeDiff) {
                    try {
                        cachedTimeDiff = JSON.parse(cachedTimeDiff);
                        var age = new Date().getTime() - cachedTimeDiff.timestamp;
                        if (age < TIME_DIFF_TTL && cachedTimeDiff.time_diff !== undefined) {
                            localStorage.setItem('time_diff', cachedTimeDiff.time_diff);
                            return;
                        }
                    } catch (e) { }
                }
                $http.get('https://time.endeksa.com/', {
                    ignoreLoadingBar: true,
                    skipAuthorization: true
                }).then(function (res) {
                    var srv_time = res.data.epochSec;
                    var cli_time = Math.floor(new Date().getTime() / 1000);
                    var time_diff = cli_time - srv_time;
                    localStorage.setItem('time_diff', time_diff);
                    localStorage.setItem(TIME_DIFF_CACHE_KEY, JSON.stringify({
                        timestamp: new Date().getTime(),
                        time_diff: time_diff
                    }));
                });
            })();

            var stVer = localStorage.getItem('current_version');
            var lastCache = localStorage.getItem('current_cache');
            $http.get(appSettingsSvc.NONCACHE + "/version", {
                ignoreLoadingBar: true
            }).then(function (res) {
                var srv_version = res.data.Version.Label;
                var cache_updates = res.data.CacheUpdates;

                var changed = false;

                if (lastCache) {
                    lastCache = JSON.parse(lastCache);

                    if (lastCache.Trend !== cache_updates.Trend) {
                        CacheFactory.get('Indices') && CacheFactory.get('Indices').removeAll();
                        changed = true;
                    }
                    if (lastCache.Demography !== cache_updates.Demography) {
                        CacheFactory.get('Demographies') && CacheFactory.get('Demographies').removeAll();
                        changed = true;
                    }
                    if (lastCache.Agents !== cache_updates.Agents) {
                        CacheFactory.get('Agents') && CacheFactory.get('Agents').removeAll();
                        CacheFactory.get('AgentsGet') && CacheFactory.get('AgentsGet').removeAll();
                        CacheFactory.get('AgentsSearch') && CacheFactory.get('AgentsSearch').removeAll();
                        changed = true;
                    }
                    if (lastCache.Malls !== cache_updates.Malls) {
                        CacheFactory.get('Malls') && CacheFactory.get('Malls').removeAll();
                        changed = true;
                    }
                    if (lastCache.Opportunity !== cache_updates.Opportunity) {
                        CacheFactory.get('OpportunitiesList') && CacheFactory.get('OpportunitiesList').removeAll();
                        CacheFactory.get('OpportunitiesGet') && CacheFactory.get('OpportunitiesGet').removeAll();
                        changed = true;
                    }
                    if (lastCache.Projects !== cache_updates.Projects) {
                        CacheFactory.get('ProjectsList') && CacheFactory.get('ProjectsList').removeAll();
                        CacheFactory.get('Projects') && CacheFactory.get('Projects').removeAll();
                        changed = true;
                    }

                }
                if (changed || !lastCache) {
                    console.log("TREND CACHE CLEANED");
                    localStorage.setItem('current_cache', JSON.stringify(cache_updates));
                }

                var vs = $("version").attr("content");
                var correctVersion =
                    stVer === $window.appVersion &&
                    vs === $window.appVersion &&
                    srv_version === $window.appVersion;

                if (!correctVersion) {
                    CacheFactory.clearAll();
                    localStorage.setItem('current_version', srv_version);
                    console.log("ALL CACHE CLEANED");
                }
            });
        }
        // Beamer Configuration with Dark Mode Support
        var isDarkMode = localStorage.getItem('darkMode') === 'true';
        $window.beamer_config = {
            product_id: "ETrLZbwu14939",
            selector: ".beamer-panel",
            language: $window.lang.toUpperCase(),
            lazy: true,
            embed: true,
            theme: isDarkMode ? 'dark' : 'default',
            // Custom filter for dark mode
            filter: isDarkMode ? 'dark-mode' : 'light-mode'
        };

        var checkBeamer = $interval(function () {
            if ($(".beamer-panel").length && $window.lang && $window.Beamer) {
                $window.Beamer.init();
                $interval.cancel(checkBeamer);
            }
        }, 100);

        // Listen for dark mode changes and update Beamer theme
        $rootScope.$on('darkMode:changed', function (event, data) {
            if ($window.Beamer) {
                var newTheme = data.enabled ? 'dark' : 'default';

                // Update Beamer config
                $window.beamer_config.theme = newTheme;
                $window.beamer_config.filter = data.enabled ? 'dark-mode' : 'light-mode';

                // Destroy and reinitialize Beamer with new theme
                if ($window.Beamer.destroy) {
                    $window.Beamer.destroy();
                }

                // Wait a bit before reinitializing
                $timeout(function () {
                    if ($(".beamer-panel").length) {
                        $window.Beamer.init();
                    }
                }, 100);
            }
        });


        var fixCanonRecursive = function (lang, path1, path2, path3, path1_o, path2_o, path3_o, path_solve, blog_path, listing_path) {

            if (blog_path) {
                path_solve = path_solve.replace(path_solve.split('/').pop(), blog_path);
            }
            if (listing_path) {
                path_solve = path_solve.replace(path_solve.split('/')[path_solve.split('/').length - 2], listing_path);
            }

            const satilik_o = $translate.instant('satilik');
            const kiralik_o = $translate.instant('kiralik');
            const konut_o = $translate.instant('konut');
            const arsa_o = $translate.instant('arsa');
            const arazi_o = $translate.instant('arazi');
            const ticari_o = $translate.instant('ticari');

            $translate(path1, {}, undefined, undefined, lang).then(function (path1_tr) {
                path_solve = path_solve.replace(path1_o, path1_tr);
                const path_lang = window.location.origin + path_solve;
                $("#lang_" + lang).attr("href", path_lang);
                // if (lang === 'en')
                //     $("#lang_x").attr("href", path_lang);

                if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                    $("#lang_" + lang).remove();
                    // if (lang === 'en')
                    //     $("#lang_x").remove();
                }
            });
            if (path2)
                $translate(path2, {}, undefined, undefined, lang).then(function (path2_tr) {
                    path_solve = path_solve.replace(path2_o, path2_tr);
                    const path_lang = window.location.origin + path_solve;
                    $("#lang_" + lang).attr("href", path_lang);
                    // if (lang === 'en')
                    //     $("#lang_x").attr("href", path_lang);

                    if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                        $("#lang_" + lang).remove();
                        // if (lang === 'en')
                        //     $("#lang_x").remove();
                    }
                });
            if (path3) {
                $translate(path3, {}, undefined, undefined, lang).then(function (path3_tr) {
                    path_solve = path_solve.replace(path3_o, path3_tr);
                    const path_lang = window.location.origin + path_solve;
                    $("#lang_" + lang).attr("href", path_lang);
                    // if (lang === 'en')
                    //     $("#lang_x").attr("href", path_lang);

                    if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                        $("#lang_" + lang).remove();
                        // if (lang === 'en')
                        //     $("#lang_x").remove();
                    }
                });
                if (path3 === 'value') {
                    $translate("satilik", {}, undefined, undefined, lang).then(function (satilik_tr) {
                        path_solve = path_solve.replace(satilik_o, satilik_tr);
                        const path_lang = window.location.origin + path_solve;
                        $("#lang_" + lang).attr("href", path_lang);
                        // if (lang === 'en')
                        //     $("#lang_x").attr("href", path_lang);


                        if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                            $("#lang_" + lang).remove();
                            // if (lang === 'en')
                            //     $("#lang_x").remove();
                        }
                    });
                    $translate("kiralik", {}, undefined, undefined, lang).then(function (kiralik_tr) {
                        path_solve = path_solve.replace(kiralik_o, kiralik_tr);
                        const path_lang = window.location.origin + path_solve;
                        $("#lang_" + lang).attr("href", path_lang);
                        // if (lang === 'en')
                        //     $("#lang_x").attr("href", path_lang);


                        if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                            $("#lang_" + lang).remove();
                            // if (lang === 'en')
                            //     $("#lang_x").remove();
                        }
                    });
                    $translate("konut", {}, undefined, undefined, lang).then(function (konut_tr) {
                        path_solve = path_solve.replace(konut_o, konut_tr);
                        const path_lang = window.location.origin + path_solve;
                        $("#lang_" + lang).attr("href", path_lang);
                        // if (lang === 'en')
                        //     $("#lang_x").attr("href", path_lang);

                        if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                            $("#lang_" + lang).remove();
                            // if (lang === 'en')
                            //     $("#lang_x").remove();
                        }
                    });
                    $translate("arsa", {}, undefined, undefined, lang).then(function (arsa_tr) {
                        path_solve = path_solve.replace(arsa_o, arsa_tr);
                        const path_lang = window.location.origin + path_solve;
                        $("#lang_" + lang).attr("href", path_lang);
                        // if (lang === 'en')
                        //     $("#lang_x").attr("href", path_lang);

                        if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                            $("#lang_" + lang).remove();
                            // if (lang === 'en')
                            //     $("#lang_x").remove();
                        }
                    });
                    $translate("arazi", {}, undefined, undefined, lang).then(function (arazi_tr) {
                        path_solve = path_solve.replace(arazi_o, arazi_tr);
                        const path_lang = window.location.origin + path_solve;
                        $("#lang_" + lang).attr("href", path_lang);
                        // if (lang === 'en')
                        //     $("#lang_x").attr("href", path_lang);

                        if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                            $("#lang_" + lang).remove();
                            // if (lang === 'en')
                            //     $("#lang_x").remove();
                        }
                    });
                    $translate("ticari", {}, undefined, undefined, lang).then(function (ticari_tr) {
                        path_solve = path_solve.replace(ticari_o, ticari_tr);
                        const path_lang = window.location.origin + path_solve;
                        $("#lang_" + lang).attr("href", path_lang);
                        // if (lang === 'en')
                        //     $("#lang_x").attr("href", path_lang);

                        if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                            $("#lang_" + lang).remove();
                            // if (lang === 'en')
                            //     $("#lang_x").remove();
                        }
                    });
                }
            }
        };
        var fixCanonical = function (transition) {
            $timeout(function () {
                const current_name = transition.to().name;
                var current_params = angular.copy(transition.params('to'));
                const path1 = current_name.split('.')[0];
                const path2 = current_name.split('.')[1];
                const path3 = current_name.split('.')[2];

                const path1_o = $translate.instant(path1);
                const path2_o = $translate.instant(path2);
                const path3_o = $translate.instant(path3);


                var blog_tr, blog_en, blog_es, blog_pt;
                if (window.blogUrls) {
                    blog_tr = window.blogUrls.find(x => x.languageType === 1) ? window.blogUrls.find(x => x.languageType === 1).name : "delete-endeksa-marker";
                    blog_en = window.blogUrls.find(x => x.languageType === 2) ? window.blogUrls.find(x => x.languageType === 2).name : "delete-endeksa-marker";
                    blog_es = window.blogUrls.find(x => x.languageType === 3) ? window.blogUrls.find(x => x.languageType === 3).name : "delete-endeksa-marker";
                    blog_pt = window.blogUrls.find(x => x.languageType === 4) ? window.blogUrls.find(x => x.languageType === 4).name : "delete-endeksa-marker";
                    window.blogUrls = undefined;
                }
                var listing_tr, listing_en, listing_es, listing_pt;

                if (window.listingUrls) {
                    listing_tr = window.listingUrls.find(x => x.Language === 1) ? window.listingUrls.find(x => x.Language === 1).Url : "delete-endeksa-marker";
                    listing_en = window.listingUrls.find(x => x.Language === 2) ? window.listingUrls.find(x => x.Language === 2).Url : "delete-endeksa-marker";
                    listing_es = window.listingUrls.find(x => x.Language === 3) ? window.listingUrls.find(x => x.Language === 3).Url : "delete-endeksa-marker";
                    listing_pt = window.listingUrls.find(x => x.Language === 4) ? window.listingUrls.find(x => x.Language === 4).Url : "delete-endeksa-marker";
                    window.listingUrls = undefined;
                }


                current_params.langcode = 'tr';
                var path_solve = $state.href(current_name, current_params);
                fixCanonRecursive('tr', path1, path2, path3, path1_o, path2_o, path3_o, path_solve, blog_tr, listing_tr);

                current_params.langcode = 'en';
                var path_solve_en = $state.href(current_name, current_params);
                fixCanonRecursive('en', path1, path2, path3, path1_o, path2_o, path3_o, path_solve_en, blog_en, listing_en);

                current_params.langcode = 'es-ES';
                var path_solve_es = $state.href(current_name, current_params);
                fixCanonRecursive('es-ES', path1, path2, path3, path1_o, path2_o, path3_o, path_solve_es, blog_es, listing_es);

                current_params.langcode = 'pt-PT';
                var path_solve_pt = $state.href(current_name, current_params);
                fixCanonRecursive('pt-PT', path1, path2, path3, path1_o, path2_o, path3_o, path_solve_pt, blog_pt, listing_pt);
            }, 1000);
        };


        window.googletag = window.googletag || {};
        $rootScope.setAds = function (id) {
            if (window.lang === 'tr')
                var interv = $interval(function () {
                    if (window.googletag.apiReady) {
                        $interval.cancel(interv);
                        googletag.cmd = googletag.cmd || [];
                        // googletag.destroySlots();
                        googletag.cmd.push(function () {
                            if (id === "div-gpt-ad-1646319323246-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_w_anasayfa', [[728, 90], [970, 90], 'fluid'], 'div-gpt-ad-1646319323246-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319558735-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_m_anasayfa', [[320, 100], 'fluid'], 'div-gpt-ad-1646319558735-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319280660-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_w_blog_anasayfa', ['fluid', [728, 90], [970, 90]], 'div-gpt-ad-1646319280660-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319514606-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_m_blog_anasayfa', ['fluid', [320, 100]], 'div-gpt-ad-1646319514606-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319230642-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_w_blog_detay', [[728, 90], 'fluid'], 'div-gpt-ad-1646319230642-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319467089-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_m_blog_haberdetay', ['fluid', [320, 100]], 'div-gpt-ad-1646319467089-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319178221-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_w_edo', [[300, 250], 'fluid'], 'div-gpt-ad-1646319178221-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319412113-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_m_edo', [[320, 100], 'fluid'], 'div-gpt-ad-1646319412113-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319094131-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_w_kdh', [[300, 250], 'fluid'], 'div-gpt-ad-1646319094131-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319372037-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_m_kdh', ['fluid', [300, 250]], 'div-gpt-ad-1646319372037-0')
                                    .addService(googletag.pubads());
                            googletag.pubads().collapseEmptyDivs(true, true);
                            googletag.enableServices();
                        });
                        googletag.display(id);
                    }
                }, 0);
        };

        var absUrl;
        $rootScope.showTopSearch = false;
        $rootScope.indexTarget = true;
        $rootScope.mapTarget = false;
        $rootScope.ad = 0;


        $transitions.onStart({}, function () {
            if (googletag && googletag._loaded_ && typeof googletag.destroySlots === 'function') {
                googletag.destroySlots();
            }

            if (typeof window.tidioChatApi !== 'undefined')
                window.tidioChatApi.close();

            absUrl = !absUrl || absUrl !== 1 ? $location.absUrl() : 1;
            window.referrer = localStorage.getItem('referrer') || document.referrer;
            if (window.referrer)
                window.dataLayer.push({
                    referrer: window.referrer,
                    currency: window.currency,
                    language: window.lang.split('-')[0]
                });
        });

        $rootScope.version = $window.appVersion;

        window.onbeforeunload = function () {
            localStorage.removeItem('referrer');
        };

        // $transitions.onRetain({}, function (transition) {
        //     console.log(transition);
        // });


        var delayHandled = false;

        $transitions.onSuccess({}, function (transition) {
            $rootScope.isActiveRefBlog = false;
            $rootScope.isActiveRefCor = false;
            $rootScope.isActiveProf = false;
            $rootScope.isActiveRefVal = false;
            $rootScope.isActiveRefReg = false;

            $rootScope.ad = $location.search().ad;
            if (transition.to().name === "default") {
                $rootScope.showTopSearch = true;
                $rootScope.indexTarget = true;
                $rootScope.mapTarget = false;
                $rootScope.landingPage = true;
                $rootScope.valuationPageMobile = false;
                $rootScope.opportunity = false;
                $rootScope.heroPage = false;
            } else if (
                // transition.to().name === "hizmetler.region" ||
                // transition.to().name === "hizmetler.location" ||
                // transition.to().name === "hizmetler.guvenle-sat" ||
                // transition.to().name === "hizmetler.danisman" ||
                // transition.to().name === "hizmetler.otomatik" ||
                transition.to().name === "urunler.uyelik" ||
                transition.to().name === "startups" ||
                transition.to().name === "agent-detail" ||
                transition.to().name === "project-detail" ||
                transition.to().name === "mall-detail"
            ) {
                $rootScope.showTopSearch = false;
                $rootScope.indexTarget = false;
                $rootScope.mapTarget = false;
                $rootScope.landingPage = false;
                $rootScope.valuationPageMobile = true;
                $rootScope.opportunity = false;
                $rootScope.heroPage = true;  // Pages with gradient heroes
            } else if (
                transition.to().name === "opportunity.listing"
            ) {
                $rootScope.showTopSearch = false;
                $rootScope.indexTarget = false;
                $rootScope.mapTarget = false;
                $rootScope.landingPage = false;
                $rootScope.valuationPageMobile = true;
                $rootScope.opportunity = false;
                $rootScope.heroPage = false;
            } else if (transition.to().name === "oppor.listing") {
                $rootScope.showTopSearch = false;
                $rootScope.indexTarget = true;
                $rootScope.mapTarget = false;
                $rootScope.landingPage = false;
                $rootScope.valuationPageMobile = false;
                $rootScope.opportunity = true;
                $rootScope.heroPage = false;
            } else if (
                transition.to().name.indexOf("address") > -1 ||
                transition.to().name.indexOf("province") > -1 ||
                transition.to().name.indexOf("country") > -1 ||
                transition.to().name.indexOf("county") > -1 ||
                transition.to().name.indexOf("address") > -1 ||
                (transition.to().name.indexOf("block") > -1 && transition.to().name.indexOf("unblock") === -1) ||
                transition.to().name.indexOf("parcel") > -1 ||
                transition.to().name.indexOf("neighbourhood") > -1
            ) {
                $rootScope.showTopSearch = true;
                $rootScope.indexTarget = false;
                $rootScope.mapTarget = true;
                $rootScope.landingPage = false;
                $rootScope.valuationPageMobile = false;
                $rootScope.opportunity = false;
                $rootScope.heroPage = false;
            } else {
                $rootScope.showTopSearch = false;
                $rootScope.indexTarget = true;
                $rootScope.mapTarget = false;
                $rootScope.landingPage = false;
                $rootScope.valuationPageMobile = true;
                $rootScope.opportunity = false;
                $rootScope.heroPage = false;
            }

            if (transition.to().name.indexOf("profile") > -1 ||
                transition.to().name.indexOf("admin") > -1 ||
                transition.to().name.indexOf("localInfo") > -1 ||
                transition.to().name.indexOf("blog") > -1 ||
                transition.to().name.indexOf("Blog") > -1 ||
                transition.to().name.indexOf("satis") > -1 ||
                transition.to().name.indexOf("property") > -1
            ) {
                $rootScope.stateAccount = true;
                //this is for stateAccount only. dont put other tags here use the conditions above
            } else {
                $rootScope.stateAccount = false;
                //this is for stateAccount only. dont put other tags here use the conditions above
            }

            if (
                transition.to().name.indexOf("blog") > -1 ||
                transition.to().name.indexOf("Blog") > -1
            ) {
                $rootScope.isActiveRefBlog = true;
            }
            else if (
                transition.to().name.indexOf("cozumler") > -1 && transition.to().name.indexOf("uyelik") === -1
            ) {
                $rootScope.isActiveRefCor = true;
            }
            else if (
                transition.to().name.indexOf("profile") > -1
            ) {
                $rootScope.isActiveProf = true;
            }
            else if (
                transition.to().name.indexOf("valuation") > -1 || transition.to().name === "nasil" || transition.to().name === "hizmetler.danisman" || transition.to().name === "hizmetler.otomatik"
            ) {
                $rootScope.isActiveRefVal = true;
            }
            else if (
                (transition.to().name.indexOf("hizmetler") > -1 && transition.to().name !== "hizmetler.danisman" && transition.to().name !== "hizmetler.otomatik") || transition.to().name.indexOf("analysis") > -1
            ) {
                $rootScope.isActiveRefReg = true;
            }

            $window.localStorage.setItem("currentState", $state.current.name);
            $rootScope.params = transition.params();

            if (window.refMobile) $rootScope.params = Object.assign({ device: 'mobile' }, $rootScope.params);

            if (transition.to().name.indexOf('danisman') === -1)
                $rootScope.address = undefined;

            var abs = absUrl && absUrl !== 1 ? angular.copy(absUrl) : $location.absUrl();
            window.localStorage.setItem('referrer', abs);


            var current = $translate.use();
            if (!current || (transition.params().langcode && current !== transition.params().langcode))
                $translate.use(transition.params().langcode).then(function () {
                    fixCanonical(transition);
                });
            else
                fixCanonical(transition);

            // if (typeof $window.Intercom !== "undefined") $window.Intercom("update");

            var path = {
                'event': "page_change",
                'original_location': abs,
                'original_path': $location.url(),
                // 'original_title': document.title,
                'currency': window.currency,
                'language': window.lang.split('-')[0]
            };

            if (window.gclid)
                path.gclid = window.gclid;

            if (window.referrer)
                path.referrer = window.referrer;

            if (window.endeksa && window.endeksa.id)
                path.user_id = window.endeksa.id;

            if (window.endeksa && window.endeksa.email || window.endeksa && window.endeksa.phone) {
                path.user_data = {};
                if (window.endeksa && window.endeksa.email)
                    path.user_data.sha256_email_address = CryptoJS.SHA256(window.endeksa.email).toString();

                if (window.endeksa && window.endeksa.phone)
                    path.user_data.sha256_phone_number = CryptoJS.SHA256(window.endeksa.phone).toString();
            }

            window.dataLayer.push(path);
            absUrl = 1;
            // $window.gtag('set', {
            //     'currency': $rootScope.currency,
            //     'user_id': $window.endeksa ? $window.endeksa.id : undefined,
            //     'email': $window.endeksa ? $window.endeksa.email : undefined,
            // });

            if (typeof dengage !== 'undefined') {
                dengage('setNavigation', transition.to().name);
            }

            if (typeof gaconnector2 !== 'undefined') {
                gaconnector2.track("f3f4769b14ea4bac184d093eb9b66cf5");
            }

            if (typeof $window.hj !== "undefined" && $window.location.host === 'www.endeksa.com') {
                $window.hj("stateChange", $location.url());
            }

            if (!delayHandled) {
                //LOAD DELAYED SCRIPTS
                var autoLoadDuration = 10; //seconds
                var eventList = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];
                var autoLoadTimeout = setTimeout(runScripts, autoLoadDuration * 1000);
                eventList.forEach(function (event) {
                    window.addEventListener(event, triggerScripts, { passive: true });
                });
                function triggerScripts() {
                    runScripts();
                    clearTimeout(autoLoadTimeout);
                    eventList.forEach(function (event) {
                        window.removeEventListener(event, triggerScripts, { passive: true });
                    });
                }
                function runScripts() {
                    Array.from(document.querySelectorAll("script[delay]")).forEach(function (scriptTag) {
                        scriptTag.setAttribute("src", scriptTag.getAttribute("delay"));
                        scriptTag.removeAttribute("delay");
                    });

                    // $timeout(function () {
                    //     if (window.location.host === 'www.endeksa.com' && typeof window.TrackJS !== 'undefined')
                    //         window.TrackJS && TrackJS.install({
                    //             token: "d9788169264a439f8267134fe3ae08c0",
                    //             application: "endeksa"
                    //         });
                    // }, 1000);
                }
                delayHandled = true;
            }

            if (
                transition.to().name
            ) {
                restoreUrlService.saveLastState(
                    transition.to().name,
                    transition.params("to")
                );
            } else if (
                transition.from().name
            ) {
                restoreUrlService.saveLastState(
                    transition.from().name,
                    transition.params("from")
                );
            }
            //endeksa panel üzerinde son ziyaret edileni tutup ona göre default yönlendirmelerde panel sayfasında sekme açalım
            if (transition.to().name.indexOf('analysis.') > -1) {
                var params = angular.copy(transition.params("to")) || {};
                params.country = $rootScope.country;
                params.top = null;
                params.ref = null;
                params.e = null;
                params.t = null;
                params.d = null;
                params.ti = null;
                params.oi = null;
                params.l = null;

                var lastPanel = {
                    name: "analysis.country." + transition.to().name.split('.')[2],
                    param: params
                };
                $window.localStorage.setItem("lastVisitedPanel", JSON.stringify(lastPanel));
            }
            window.scrollTo(0, 0);
            //bazı sayfaların render süresi sarkabiliyor.
            $timeout(function () {
                window.scrollTo(0, 0);

                //check if user settings force language change
                const langChange = window.localStorage.getItem("ChangeLanguage");
                if (langChange) {
                    window.localStorage.removeItem("ChangeLanguage");
                    $rootScope.changeLanguageRoot(null, langChange);
                }
            });
        });
        $transitions.onError({}, function (transition) {
            var rejection = transition.error();

            // Handling different types of errors
            if (rejection.type === 6 && (!rejection.detail || !rejection.detail.message || rejection.detail.message.indexOf('Unable to load') === -1)) {
                // Error handling for specific type of error
                console.error("Transition name", transition.to().name);
                console.error("Transition error", transition.error());
                transition.abort();
                // Full page redirect to get proper 404 HTTP status code from server
                $window.location.replace("/" + ($window.lang || "en") + "/404");
            } else if (rejection.type === 6 && rejection.detail && rejection.detail.message && rejection.detail.message.indexOf('Unable to load') > -1) {
                // Error handling for another type of error
                transition.abort();
                $timeout(function () {
                    console.error("Lazyload error", rejection.detail.message);
                    $window.location.reload();
                }, 500);
            }
        });

        // documentClicked on document
        angular.element(document).on("click", function (e) {
            try {
                $rootScope.$broadcast("documentClicked", angular.element(e.target));
            }
            catch (err) {
                //ignored
            }
        });
    }
})();
